module.exports = __webpack_public_path__ + "static/media/Youmaihuixun_2.dbf9fb11.png";